module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "preface-title"
  }, [_c('span', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "toc-copyright"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    attrs: {
      "href": "#/dedication",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "toc-preface001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/preface001"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "toc-preface002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/preface002"
    }
  }, [_vm._v("Introduction: Mother McCloud")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_vm._v("1.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_vm._v("The Fountain of Youth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter002"
    }
  }, [_vm._v("2.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/chapter002"
    }
  }, [_vm._v("Who Gets to Drink?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Is It Safe to Drink the Water?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Death in Small Doses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flint")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blue Terror")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bigger Than Soft Drinks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Need Versus Greed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding Water for the Twenty-first Century")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "toc-appendix001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/appendix001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword: A Glass Half Empty/A Glass Half Full")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "toc-endnotes"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/endnotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "toc-index001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/index001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78a90703","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 66
// module chunks = 0